import { RequestStatus } from "@/models/underwriting";

export { formatTimeAgo } from "@/helpers/dateUtils";

export const STATUS_STYLES: Record<RequestStatus, { label: string; className: string }> = {
  Pending: { label: "Pending", className: "text-[11px] border-slate-200 bg-slate-100 text-slate-600" },
  InReview: { label: "In Progress", className: "text-[11px] border-amber-200 bg-amber-100 text-slate-700" },
  Approved: { label: "Approved", className: "text-[11px] border-emerald-200 bg-emerald-100 text-slate-700" },
  Declined: { label: "Declined", className: "text-[11px] border-rose-200 bg-rose-100 text-slate-700" },
  Alternative: { label: "Alternative", className: "text-[11px] border-blue-200 bg-blue-100 text-slate-700" },
  MoreInfo: { label: "More Info", className: "text-[11px] border-violet-200 bg-violet-100 text-slate-700" },
  Cancelled: { label: "Cancelled", className: "text-[11px] border-slate-200 bg-slate-100 text-slate-500" },
};
